import React from 'react';
import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';

interface DeactivateErrorModalProps {
  onClose: () => void;
}

export const DeactivateErrorModal = ({ onClose }: DeactivateErrorModalProps) => {
  return (
    <ModalTransition>
      <Modal onClose={onClose} testId="deactivate-error-modal">
        <ModalHeader>
          <ModalTitle appearance="warning">Can't deactivate this billing profile</ModalTitle>
        </ModalHeader>
        <ModalBody>
          This billing profile has either an active subscription, open invoice or open quote associated with it. Please
          move the active subscription or open quote to another billing profile and pay the open invoices before
          deactivating this billing profile.
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
};
